// extracted by mini-css-extract-plugin
export var answer = "Question-module--answer--5fwax";
export var container = "Question-module--container--vpZeX";
export var iconWrapper = "Question-module--icon-wrapper--+q2Tj";
export var link = "Question-module--link--gV+Rt";
export var title = "Question-module--title--00JpW";
export var titleBenefits = "Question-module--title-benefits--YHMjH";
export var titleContainer = "Question-module--title-container--bDxXM";
export var titleContainerBenefits = "Question-module--title-container-benefits--ARyEW";